import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function ThankYou() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // If still authenticated, redirect to home (shouldn't happen, but safety check)
    if (isAuthenticated) {
      navigate("/");
      return;
    }

    // Auto-redirect to login after 5 seconds
    const timer = setTimeout(() => {
      navigate("/login", { replace: true });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, isAuthenticated]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#FFFFFF",
        background: "linear-gradient(135deg, #FFFFFF 0%, #F0F8FF 50%, #E6F3FF 100%)",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            p: 6,
            bgcolor: "#FFFFFF",
            borderRadius: 3,
            border: "1px solid",
            borderColor: "#87CEEB",
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 80,
              color: "#87CEEB",
              mb: 3,
            }}
          />

          <Typography
            variant="h4"
            sx={{
              color: "#87CEEB",
              fontWeight: 700,
              mb: 2,
              textShadow: "0 0 8px rgba(135, 206, 235, 0.4)",
            }}
          >
            Thank You!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "black",
              mb: 4,
              fontSize: "1.1rem",
            }}
          >
            You have been successfully logged out.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "grey.700",
              mb: 4,
            }}
          >
            Redirecting to login page in 5 seconds...
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/login")}
            sx={{
              bgcolor: "#87CEEB",
              color: "#FFFFFF",
              fontWeight: 600,
              px: 4,
              py: 1.5,
              "&:hover": {
                bgcolor: "#00BFFF",
              },
            }}
          >
            Go to Login
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}

